import styled from 'styled-components';

export const LoaderContainer = styled.div`
    & {
        display: flex;
        justify-content: center;
        align-items: center;
    }

    @keyframes rotating {
        from {
            transform: rotate(0deg);
        }
        to {
            transform: rotate(360deg);
        }
    }
    .loader-container {
        width: 34px;
        height: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .loader {
        color: ${(props) => props.theme.palette.primaryA1};
        animation: rotating 2s linear infinite;
    }

    .text {
        margin-top: 6px;
    }
`;
